import type { CSSProperties } from 'react';

import type { CompositionNorthArrowStyle } from '../../../composition/model';
import { northArrowPrimitives } from '../../../composition/northArrow';

export function NorthArrowSymbol({
  symbolStyle,
  showLabel,
  className,
  style,
}: {
  readonly symbolStyle: CompositionNorthArrowStyle;
  readonly showLabel: boolean;
  readonly className?: string;
  readonly style?: CSSProperties;
}) {
  return (
    <svg aria-hidden="true" className={className} style={style} viewBox="0 0 100 100">
      {showLabel ? (
        <text fill="currentColor" fontSize="23" fontWeight="700" textAnchor="middle" x="50" y="21">
          N
        </text>
      ) : null}
      {northArrowPrimitives(symbolStyle).map((primitive, index) => {
        const colour = (paint: 'foreground' | 'white' | undefined) =>
          paint === 'white' ? '#ffffff' : paint ? 'currentColor' : 'none';
        const cutoutPath =
          primitive.kind === 'circle' && primitive.cutouts?.length
            ? `M${primitive.centre[0] + primitive.radius} ${primitive.centre[1]} A${primitive.radius} ${primitive.radius} 0 1 0 ${primitive.centre[0] - primitive.radius} ${primitive.centre[1]} A${primitive.radius} ${primitive.radius} 0 1 0 ${primitive.centre[0] + primitive.radius} ${primitive.centre[1]} Z ${primitive.cutouts
                .map(
                  ({ points }) =>
                    `${points
                      .map(([x, y], pointIndex) => `${pointIndex === 0 ? 'M' : 'L'}${x} ${y}`)
                      .join(' ')} Z`,
                )
                .join(' ')}`
            : null;
        if (primitive.kind === 'circle' && cutoutPath) {
          return (
            <path d={cutoutPath} fill={colour(primitive.fill)} fillRule="evenodd" key={index} />
          );
        }
        return primitive.kind === 'circle' ? (
          <circle
            cx={primitive.centre[0]}
            cy={primitive.centre[1]}
            fill={colour(primitive.fill)}
            key={index}
            r={primitive.radius}
            stroke={colour(primitive.stroke)}
            strokeWidth={primitive.strokeWidth}
          />
        ) : (
          <path
            d={`${primitive.points
              .map(([x, y], pointIndex) => `${pointIndex === 0 ? 'M' : 'L'}${x} ${y}`)
              .join(' ')}${primitive.closed ? ' Z' : ''}`}
            fill={colour(primitive.fill)}
            key={index}
            stroke={colour(primitive.stroke)}
            strokeLinejoin="round"
            strokeLinecap={primitive.lineCap ?? 'round'}
            strokeWidth={primitive.strokeWidth}
          />
        );
      })}
    </svg>
  );
}
